module.exports = __webpack_public_path__ + "img/retail-banner.e5004bab.png";